import { render, staticRenderFns } from "./DhmeBillOfMaterialObjects.vue?vue&type=template&id=5f7edbec&scoped=true"
import script from "./DhmeBillOfMaterialObjects.vue?vue&type=script&lang=js"
export * from "./DhmeBillOfMaterialObjects.vue?vue&type=script&lang=js"
import style0 from "./DhmeBillOfMaterialObjects.vue?vue&type=style&index=0&id=5f7edbec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7edbec",
  null
  
)

export default component.exports